export const AMPLITUDE_DEFAULT_INSTANCE = '$default_instance';
